/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Analytics_Uniquesessions1Inputs */

const zh_analytics_uniquesessions1 = /** @type {(inputs: Analytics_Uniquesessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`独立会话数`)
};

const en_analytics_uniquesessions1 = /** @type {(inputs: Analytics_Uniquesessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unique Sessions`)
};

const es_analytics_uniquesessions1 = /** @type {(inputs: Analytics_Uniquesessions1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sesiones únicas`)
};

/**
* | output |
* | --- |
* | "Unique Sessions" |
*
* @param {Analytics_Uniquesessions1Inputs} inputs
* @param {{ locale?: "zh" | "en" | "es" }} options
* @returns {LocalizedString}
*/
const analytics_uniquesessions1 = /** @type {((inputs?: Analytics_Uniquesessions1Inputs, options?: { locale?: "zh" | "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Analytics_Uniquesessions1Inputs, { locale?: "zh" | "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh") return zh_analytics_uniquesessions1(inputs)
	if (locale === "en") return en_analytics_uniquesessions1(inputs)
	return es_analytics_uniquesessions1(inputs)
});
export { analytics_uniquesessions1 as "analytics_uniqueSessions" }